import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThankYou from "../pages/home/thank-you/page";
import AdminDashboard from "../pages/admin/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import LinksPage from "../pages/links/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/thank-you",
    element: <ThankYou />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/links",
    element: <LinksPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;